import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import toast, { Toaster } from 'react-hot-toast';

import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetVacancies } from '../../../redux/action/recruiting/actionVacancy';
import { actionGetRoutes } from '../../../redux/action/projects/actionRoutes';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import Pagination from '../../pagination/pagination';
import ToastPopup from '../../custom/toastPopup/toastPopup';
import { generateStyles } from '../../../utils/generateToastStyles';
import {
  reducerApplicationChange,
  reducerSelectedVacancies,
  reducerSelectedVacanciesId,
  reducerVacancyStatus,
} from '../../../redux/reducer/recruiting/reducers/reducerVacancy';
import { formatReports } from '../../../utils/formatReports';
import Loader from '../../custom/loader/loader';

import styles from '../headerBtn.module.scss';
import '../../table/table.scss';

interface ISectionOptions {
  title: string;
}

const NewApplication: FC<ISectionOptions> = ({ title }) => {
  const dispatch: any = useDispatch<AppDispatch>();
  const {
    data,
    limit,
    page,
    count,
    checkboxes,
    selectedVacanciesId,
    clientsStatus,
    clientsStatusMessage,
    applicationData,
    isPending,
    vacancyListSettings,
  } = useSelector((state: any) => state.recruiting.vacancyList);

  const requestStatusOptions = [
    {
      status: 400,
      errorMessage: clientsStatusMessage,
    },
    {
      status: 200,
      successMessage: 'Вакансия создана!',
    },
  ];

  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
    useState<boolean>(false);
  const [isCheckedRows, setIsCheckedRows] = useState<boolean[]>(checkboxes);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [next, setNext] = useState<boolean>(false);

  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

  useEffect(() => {
    if (selectedVacanciesId && !selectedVacanciesId.length) {
      setIsCheckedRows(data && checkboxes);
      setIsHeaderCheckboxChecked(false);
    }
  }, [checkboxes, data, selectedVacanciesId]);

  useEffect(() => {
    const updatedCheckedRows =
      data &&
      data.reduce((acc: any, vacancy: any) => {
        const vacancyId = vacancy.vacancy.id;
        acc[vacancyId] = isHeaderCheckboxChecked;
        return acc;
      }, {});

    dispatch(reducerSelectedVacanciesId(formatReports(updatedCheckedRows)));
    setIsCheckedRows(updatedCheckedRows);
  }, [dispatch, isHeaderCheckboxChecked, data]);

  useEffect(() => {
    return () => {
      dispatch(reducerApplicationChange(
        {
          firstName: '',
          lastName: '',
          gender: 'Male'
        }
      ))
    }
  }, [dispatch]);

  const handleRowCheckboxChange = (el: any) => {
    const vacancyId = el.vacancy.value.id;
    setIsCheckedRows((prevCheckedRows: any) => ({
      ...prevCheckedRows,
      [vacancyId]: !prevCheckedRows[vacancyId],
    }));

    const updatedSelectedVacancies = formatReports({
      ...isCheckedRows,
      [vacancyId]: !isCheckedRows[vacancyId],
    });

    dispatch(reducerSelectedVacanciesId(updatedSelectedVacancies));
    dispatch(reducerSelectedVacancies(updatedSelectedVacancies.length ? el : {}));
  };

  const handleChange = (newLimit: number, newPage: number) => {

    dispatch(actionGetVacancies(newLimit, newPage)).then(() => {

    });
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };

  useEffect(() => {
    dispatch(actionGetVacancies(actualLimit, page));
  }, [actualLimit, dispatch, page]);

  useEffect(() => {
    requestStatusOptions.forEach((option: any) => {
      if (clientsStatus === option.status) {
        toast.dismiss();

        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false)
        );
      }
    });

    setTimeout(() => {
      dispatch(reducerVacancyStatus(null));
    }, 5000);
    // eslint-disable-next-line
  }, [dispatch, clientsStatus]);

  useEffect(() => {

    dispatch(actionGetRoutes(limit, page)).then(() => {

    });
  }, [actualLimit, dispatch, limit, page]);

  // eslint-disable-next-line
  const handleNext = () => {
    setNext(!next)
  }

  const handleChangeApplication = (e: any) => {
    dispatch(reducerApplicationChange({
      ...applicationData,
      [e.target.name]: e.target.value
    }))
  }
  return (
    <>
      {!next && <div>
        <div className='loader__wrapper'>
          {((data && !data.length) || isPending) && <Loader />}
        </div>

        <div >
          {(clientsStatus && clientsStatus!==null) && <Toaster
            position='top-center'
            toastOptions={{
              duration: 5000,
            }}
          />}
          <div className='table__wrapper table__wrapper-application'>
            <table>
              <thead>
                <tr>
                  <th className='reports__checkbox_block'></th>
                  {vacancyListSettings.includes('vacancyId') && <th>
                    <div className='filter__number_block'>
                      <input
                        name='posClientId'
                        placeholder=' '
                        type='number'
                      />
                      <label>ID</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('type') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Тип вакансии'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}
                  {vacancyListSettings.includes('regions') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Регион'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('areas') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Область'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('cities') && <th style={{ minWidth: '180px' }}>
                    <div className='filter__block'>
                      <input
                        autoComplete='off'
                        placeholder=' '
                        name='cities'
                        type='text'
                      />
                      <label>Город</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('addresses') && <th style={{ minWidth: '280px' }}>
                    <div className='filter__block'>
                      <input
                        autoComplete='off'
                        placeholder=' '
                        name='addresses'
                        type='text'
                      />
                      <label>Адрес</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('merchs') && <th style={{ minWidth: '280px' }}>
                    <div className='filter__block'>
                      <input
                        autoComplete='off'
                        placeholder=' '
                        name='login'
                        type='text'
                      />
                      <label>Логин/Локация</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('vacancyName') && <th style={{ minWidth: '180px' }}>
                    <div className='filter__block'>
                      <input
                        autoComplete='off'
                        placeholder=' '
                        name='name'
                        type='text'
                      />
                      <label>Название вакансии</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('status') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Статус'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('projectName') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Проект'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('routeNo') && <th>
                    <div className='filter__number_block'>
                      <input
                        autoComplete='off'
                        placeholder=' '
                        name='routes'
                        type='number'
                      />
                      <label>Маршрут</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('vsv') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='ВСВ'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('sv') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Супервайзер'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('schedule') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        inputValues={[]}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='График'
                        name='regions'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('salary') && <th>
                    <div className='fromToFilter'>
                      <span>Зарплата</span>
                      <div className='filter__number_block'>
                        <input
                          name='fromSalary'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          name='toSalary'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('revenue') && <th>
                    <div className='fromToFilter'>
                      <span>Выручка</span>
                      <div className='filter__number_block'>
                        <input
                          name='fromRevenue'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          name='toRevenue'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                </tr>

              </thead>

              <tbody>
                {data && data.map((el: any, index: number) => (
                  <tr className='active__link_tr' key={index}>
                    <td>
                      <input
                        disabled={
                          selectedVacanciesId &&
                          selectedVacanciesId.length >= 1 &&
                          selectedVacanciesId.some(
                            (item: any) => item.id !== el.vacancy.value.id
                          )
                        }
                        onChange={() => handleRowCheckboxChange(el)}
                        checked={
                          (isCheckedRows && isCheckedRows[el.vacancy.value.id]) || false
                        }
                        className='relative__elem'
                        type='checkbox'
                      />
                    </td>

                    {vacancyListSettings.includes('vacancyId') && <td>
                      <span className='relative__elem'>{el?.vacancy?.value?.id}</span>
                    </td>}

                    {vacancyListSettings.includes('type') && <td>
                      <span className='relative__elem'>
                        {Object.values(el.type.value)}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('regions') && <td>
                      <span className='relative__elem'>
                        {el?.regions?.valueAll?.map((item: { name: string }, index: number) => (
                          <span key={item.name}>
                            {el?.regions?.valueAll?.length > 1 ? index === el?.regions?.valueAll?.length - 1 ? item.name : `${item.name}, ` : item.name}
                          </span>
                        ))}                      </span>
                    </td>}

                    {vacancyListSettings.includes('areas') && <td>
                      <span className='relative__elem'>
                        {el?.areas?.valueAll?.map((item: { name: string }, index: number) => (
                          <span key={item.name}>
                            {el?.areas?.valueAll?.length > 1 ? index === el?.areas?.valueAll?.length - 1 ? item.name : `${item.name}, ` : item.name}
                          </span>
                        ))}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('cities') && <td>
                      <span className='relative__elem'>
                        {el?.cities?.valueAll ? el?.cities?.valueAll?.join(', ') : ''}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('addresses') && <td>
                      <span className='relative__elem'>
                        {el?.addresses?.valueAll !== null && el?.addresses?.valueAll?.map((item: any, index: number) => (
                          <span key={index} className='relative__elem_span'>
                            {el?.addresses?.valueAll?.length > 1 ? index === el?.addresses?.valueAll?.length - 1 ? item : `${item}; ` : item}
                          </span>
                        ))}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('merchs') && <td>
                      <span className='relative__elem'>
                        {el?.merchs?.valueAll ? el?.merchs?.valueAll?.join(', ') : ''}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('vacancyName') && <td>
                      <span className='relative__elem'>{el?.name.value}</span>
                    </td>}

                    {vacancyListSettings.includes('status') && <td>
                      <span className='relative__elem'>
                        {Object.values(el.status.value)}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('projectName') && <td>
                      {el.projects?.value &&
                        el.projects?.value.map((item: any, index: number) => (
                          <span key={index} className='relative__elem'>
                            {item && item.name}{index !== el.projects.value.length - 1 && ', '}
                          </span>
                        ))}
                    </td>}

                    {vacancyListSettings.includes('routeNo') && <td>
                      {el?.routes?.valueAll ? el?.routes?.valueAll?.join(', ') : ''}
                    </td>}

                    {vacancyListSettings.includes('vsv') && <td>
                      {el.virtualSupervisors?.valueAll &&
                        el.virtualSupervisors?.valueAll.map((item: any, index: number) => (
                          <span key={index} className='relative__elem'>
                            {item.employee && item.employee.name}{index !== el.virtualSupervisors.valueAll.length - 1 && ', '}
                          </span>
                        ))}
                    </td>}

                    {vacancyListSettings.includes('sv') && <td>
                      {el.supervisors?.valueAll &&
                        el.supervisors?.valueAll.map((item: any, index: number) => (
                          <span key={index} className='relative__elem'>
                            {item.employee && item.employee.name.slice(0, -1)}{index !== el.supervisors.valueAll.length - 1 && ', '}
                          </span>
                        ))}
                    </td>}

                    {vacancyListSettings.includes('schedule') && <td>
                      {el.schedule?.valueAll && (
                        <span className='relative__elem'>
                          {el.schedule.valueAll.length === 1 ? (
                            Object.values(el.schedule.valueAll[0]).toString()
                          ) : (
                            el.schedule.valueAll.map((item: any, index: number) => (
                              <span key={index}>
                                {Object.values(item).toString()}
                                {index !== el.schedule.valueAll.length - 1 && ', '}
                              </span>
                            ))
                          )}
                        </span>
                      )}</td>}

                    {vacancyListSettings.includes('salary') && <td>
                      <span className='relative__elem'>
                        {(el.salary.value || 0) + (el.salary.ext || 0)}
                      </span>
                    </td>}

                    {vacancyListSettings.includes('revenue') && <td>
                      <span className='relative__elem'>
                        {(el?.revenue?.value || 0) + (el?.revenue?.ext || 0)}
                      </span>
                    </td>}

                  </tr>
                ))}
              </tbody>
            </table>
            {(data !== null && !data.length) && <div>Нет данных</div>}
          </div>

          <div className='pagination'>
            <div className='pagination__count'>Всего: {count}</div>
            <div className='pagination__str'>
              <span>Отображать строки</span>
              <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
            </div>
            <Pagination
              setCurrentPage={setCurrentPage}
              setStartPage={setStartPage}
              handleChange={handleChange}
              count={count}
              currentPage={currentPage}
              startPage={startPage}
              limit={actualLimit}
              pageName='userReports'
            />
          </div>
        </div>
      </div>}

      {next &&
        <div className={styles.application__create}>
          <div className='filter__block'>
            <input
              onChange={handleChangeApplication}
              value={applicationData.firstName}
              autoComplete='off'
              placeholder=' '
              name='firstName'
              id='firstName'
              type='text'
            />
            <label>Имя</label>
          </div>
          <div className='filter__block'>
            <input
              onChange={handleChangeApplication}
              value={applicationData.lastName}
              autoComplete='off'
              placeholder=' '
              name='lastName'
              id='lastName'
              type='text'
            />
            <label>Фамилия</label>
          </div>

          <fieldset className={styles.application__gender} onChange={handleChangeApplication}>
            <legend>Выберите пол:</legend>

            <div>
              <input
                type="radio"
                name="gender"
                value='Male'
                id='Male'
                checked={applicationData.gender === 'Male'}
                onChange={handleChangeApplication}
              />
              <label htmlFor="Male">Мужской</label>
            </div>

            <div>
              <input
                type="radio"
                name="gender"
                value='Female'
                id='Female'
                checked={applicationData.gender === 'Female'}
                onChange={handleChangeApplication}
              />
              <label htmlFor="Female">Женский</label>
            </div>
          </fieldset>
        </div>
      }
    </>
  );
};

export default NewApplication;
